<div class="content">
  <div class="table-container mat-elevation-z3">

    <table mat-table [dataSource]="items" matSort matSortActive="shopName" matSortDirection="asc" matSortDisableClear
      [matSortDirection]="sortDirection" [matSortActive]="sortColumn" (matSortChange)="onSortData($event)">

      <ng-container matColumnDef="brands">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.brand' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <div class="brand">
            <img class="logo" [src]="brandService.getLogoById(element.brandId)" />
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="shopNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.shop-number' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.shopNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="shopName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.shop-name' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.shopName}} </td>
      </ng-container>

      <ng-container matColumnDef="street">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'administration.shops.street' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.street}} </td>
      </ng-container>

      <ng-container matColumnDef="postcode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'administration.shops.postcode' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.postcode}} </td>
      </ng-container>

      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'administration.shops.city' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.city}} </td>
      </ng-container>

      <ng-container matColumnDef="phoneNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'administration.shops.phone-number' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.phoneNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="emailAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'administration.shops.email' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.emailAddress}} </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> {{'common.actions' | translate}} </th>
        <td mat-cell *matCellDef="let element;">
          <div class="row">
            <button mat-mini-fab color="primary" matTooltip="{{'administration.shops.edit' | translate}}"
              aria-label="Edit shop" (click)="addOrEditShopOpenDialog(element.id)" *ngIf="authService.hasPermission(permissionEnum.EditShop)">
              <fa-icon [icon]="faShopEdit"></fa-icon>
            </button>
            <button mat-mini-fab color="primary" matTooltip="{{'administration.shops.printers-in-shop' | translate}}"
              aria-label="Printers in shop" (click)="onPrintersInShop(element)">
              <fa-icon [icon]="faPrinters"></fa-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container *ngFor="let column of columns" [matColumnDef]="column.filter.name">
        <th mat-header-cell *matHeaderCellDef="let element">
          <app-table-filter #filterRefs [column]="column" [filter]="filter" (filterChange)="filterData($event)"></app-table-filter>
        </th>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-header-row *matHeaderRowDef="filterColumns; sticky: true" class="filters"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>

    <div class="empty-results" *ngIf="items.length === 0">{{'common.empty-results' | translate}}
    </div>

    <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageIndex]="pageIndex" color="primary"
      [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event; onPaginateChange($event)" showFirstLastButtons
      class="mat-paginator-row">
    </mat-paginator>
  </div>
</div>